import { render, staticRenderFns } from "./RegistrationDetailsCard.vue?vue&type=template&id=63d23a47&"
import script from "./RegistrationDetailsCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports